import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Remove the instant splash once the app has mounted (subtle fade).
requestAnimationFrame(() => {
  const splash = document.getElementById("app-splash");
  if (splash) {
    splash.classList.add("stp-hide");
    setTimeout(() => splash.remove(), 400);
  }
});

// Register the push service worker on boot (independent of enabling notifications). A registered SW
// with a fetch handler is part of Chrome's Android installability signal, so this is what lets STP OS
// be offered as a proper "Install app" (WebAPK) instead of a home-screen shortcut. The SW must be scoped
// to match the WebAPK the visitor will install: the CLIENT PWA is scoped to /my (so its notifications
// attribute to the installed client app, not Chrome), while the coach PWA uses the root scope. Mirrors
// the role split used for manifest selection in public/index.html.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    var isClient = window.location.pathname.indexOf("/my") === 0;
    var opts = isClient ? { scope: "/my" } : undefined;
    navigator.serviceWorker.register("/push-sw.js", opts).catch(() => {});
  });
}
